import * as React from 'react'

import { Box, Filters, SearchField, Table } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import createComputed from 'modules/core/hooks/createComputed'
import { useDebouncedSearch } from 'modules/core/hooks/useSearch'
import i18n from 'modules/core/lib/i18n'

import complaints from 'modules/complaints/store/collections/complaints'
import type Complaint from 'modules/complaints/store/models/Complaint'

import Body from './Body'
import Options, { ComplaintsFilters } from './_Filters'
import { filterBySearch, filterByStatus } from './filtering'

const useFilterAndSort = createComputed(
  (complaints: Complaint[], search: string, status: string) => {
    const filteredBySearch = filterBySearch(complaints, search)
    const filteredByStatus = filterByStatus(filteredBySearch, status)

    const sortedComplaints = filteredByStatus.sort((a, b) => (a.createdAt > b.createdAt ? -1 : 1))

    return sortedComplaints
  }
)
interface Props {
  onComplaintSelect: (id: number | null) => void
  selectedComplaint: number | null
}

function ComplaintsTable({ onComplaintSelect, selectedComplaint }: Props) {
  const filtersForm = React.useRef(new ComplaintsFilters({})).current
  const { search, onSearch: onDebouncedSearch } = useDebouncedSearch()
  const statusFilter = filtersForm.get('status').value

  const filteredComplaints = useFilterAndSort(complaints.toArray(), search, statusFilter).get()

  const unselectComplaint = () => onComplaintSelect(null)

  const onSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    onDebouncedSearch(event)
    unselectComplaint()
  }

  const FiltersOptions = () => (
    <Options
      complaints={complaints.toArray()}
      filtersForm={filtersForm}
      onFilterChange={unselectComplaint}
    />
  )

  const TableOptions = () => (
    <Box flexDirection="row" gap="s8" flexGrow alignItems="center">
      <Filters
        label={i18n.t('complaints.table.filters.label')}
        title={i18n.t('complaints.table.filters.title')}
        description={i18n.t('complaints.table.filters.description')}
        options={FiltersOptions}
        attachment="middle left"
      />
      <Box width="full">
        <SearchField
          variant="big"
          search={search}
          onSearch={onSearch}
          placeholder={i18n.t('common.search_by')}
        />
      </Box>
    </Box>
  )

  return (
    <Table options={TableOptions} fullWidth>
      <Body
        complaints={filteredComplaints}
        onComplaintSelect={onComplaintSelect}
        selectedComplaint={selectedComplaint}
      />
    </Table>
  )
}

export default observer(ComplaintsTable)
